import styled from 'styled-components';

export const Container = styled.div`
  max-width: max-content;
  height: 100%;
  border: 1px solid var(--green_so_club);
  border-radius: 0.3rem;

  .so-component-item-content {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.4rem;
    background-color: var(--white);
  }

  .club-header-images {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    width: 100%;
    color: var(--green_so_club_2);
    background-color: rgba(62, 153, 10, 0.21);
    font-weight: 700;
    height: 1.4rem;

    img {
      width: 1.2rem;
      height: 1.2rem;
    }
  }

  .so-component-message {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0.4rem;
    height: 103%;
    border-radius: 3rem 0.4rem 0.4rem 3rem;
    font-family: 'Roboto', sans-serif;
    color: var(--black);
    font-size: 0.7rem;
    font-weight: 500;

    p b {
      &.price {
        text-decoration: none;
        white-space: nowrap;
      }
    }
  }
`;
